const SkeletonProcess = () => {
  return (
    <>
      <div className="card-image card-image__skeleton"></div>
      <div className="card-content">
        <div className="card-process_head">
          <div className="card-process_type card-process_type__skeleton"></div>
          <div className="card-process_title card-process_title__skeleton"></div>
        </div>
        <div className="card-process_info card-process_info__skeleton"></div>
        <div className="card-process_action">
          <div className="main-button main-button__skeleton"></div>
        </div>
      </div>
    </>
  );
};

export default SkeletonProcess;
